import Home from '../page/Home';
import Projects from '../page/Projects';
import routes from '../configs';
import HomeLayout from '../Layouts/HomeLayout';
import HeaderOnly from '~/Layouts/HeaderOnly';
import CvPage from '~/page/CvPage';
import EmptyLayout from '~/Layouts/EmptyLayout';
import CreatePostPage from '~/page/CreatePostPage';
import ProjectDetailPage from '~/page/ProjectDetailPage/ProjectDetailPage';
import NotePage from '~/page/NotePage/NotePage';
import MusicPlayer from '~/component/MusicPlayer';
import NotFoundPage from '~/page/NotFoundPage';
import LoginPage from '~/page/LoginPage/LoginPage';
import PostPage from '~/page/PostPage';
import TipDetail from '~/page/TipDetail';
import TipsPage from '~/page/TipsPage';
import EditCv from '~/page/EditCv';
import AdminMessagePage from '~/page/AdminMessagePage';
import AboutPage from '~/page/AboutPage';
import ProductDetail from '~/page/ProductDetail';
import ShopifyProductList from '~/Layouts/components/ShopifyProductList/ShopifyProductList';
import WebsiteService from '~/page/WebsiteService';
import AdminProjectTypes from '~/page/AdminProjectTypes';

export const publicRouters = [
  {
    component: Home,
    path: routes.home,
    layout: HomeLayout,
  },
  {
    component: AdminMessagePage,
    path: routes.admin,
    layout: HeaderOnly,
  },
  {
    component: AboutPage,
    path: routes.about,
    layout: HeaderOnly,
  },
  {
    component: Projects,
    path: routes.projects,
    layout: HeaderOnly,
  },
  {
    component: CvPage,
    path: routes.cV,
    layout: EmptyLayout,
  },
  {
    component: EditCv,
    path: routes.editCv,
    layout: EmptyLayout,
  },
  {
    component: CreatePostPage,
    path: routes.createPost,
    layout: HeaderOnly,
  },
  {
    component: ProjectDetailPage,
    path: routes.projectDetail + '/:id',
    layout: HeaderOnly,
  },
  {
    component: NotePage,
    path: routes.notePage,
    layout: EmptyLayout,
  },
  {
    component: MusicPlayer,
    path: routes.music,
    layout: HeaderOnly,
  },
  {
    component: NotFoundPage,
    path: routes.notFound,
    layout: EmptyLayout,
  },
  {
    component: LoginPage,
    path: routes.login,
    layout: EmptyLayout,
  },
  {
    component: PostPage,
    path: routes.post,
    layout: HeaderOnly,
  },
  {
    component: TipDetail,
    path: routes.tipDetail + '/:id',
    layout: HeaderOnly,
  },
  {
    component: TipsPage,
    path: routes.tipspage,
    layout: HeaderOnly,
  },
  
  {
    path: routes.productDetail,
    component: ProductDetail,
    layout: EmptyLayout,
  },
  {
    path: routes.shop,
    component: ShopifyProductList,
    layout: EmptyLayout,
  },
  {
    path: routes.service,
    component: WebsiteService,
    layout: EmptyLayout,
  },
  {
    path: routes.projectTypes,
    component: AdminProjectTypes,
    layout: EmptyLayout,
  },
];

export const privateRouters = [];
